import {Deserialize, ISerializable, Serialize} from 'cerialize';
import {RsvpOpenAnswer} from '../../models/rsvp-open-answer';
import {RsvpMultipleChoiceAnswer} from '../../models/rsvp-multiple-choice-answer';
import {RsvpAnswer} from '../../models/rsvp-answer';

export const RsvpAnswerTransformer: ISerializable = {
  Serialize(value: RsvpAnswer): string {
    return Serialize(value);
  },
  Deserialize(json: any): any {
    if (json) {
      if (Array.isArray(json)) {
        return json.map(this.Deserialize);
      }
      if (json.type === 'RsvpMultipleChoiceAnswer') {
        return Deserialize(json, RsvpMultipleChoiceAnswer);
      }
      if (json.type === 'RsvpOpenAnswer') {
        return Deserialize(json, RsvpOpenAnswer);
      }
    }
    return null;
  }
};
